import { useState, useEffect, useContext, useRef } from 'react'
import { useLocation, useHistory }      from 'react-router-dom'
import { SceneContext }     from './SceneContext'
import DevMenu              from './DevMenu'
import SceneMenu            from './SceneMenu'
import AudioBox             from './AudioBox'
import NavButton            from './NavButton'
import Menu                 from './Menu'
import Map                  from './Map'
import Moveable             from 'react-moveable'
import KeyController        from "keycon"
import Loader               from "react-loader-spinner"
import './css/App.css'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

let state, setState, location, history, context, mov_ref, video_ref, audio_ref
let last_top, last_left, last_transform

export default function App() {

    [state, setState] = useState({
        stageWidth: 1280,
        stageHeight: 720,
        video_loaded: false,
        scale: 0,
        fs: false
    })

    context   = useContext(SceneContext)
    location  = useLocation()
    history   = useHistory()
    mov_ref   = useRef()
    video_ref = useRef()
    audio_ref = useRef()

    useEffect(() => startup(), [])  // Startup effect

    useEffect(()=> {
        if(context.require_user_click == false) {
            if(context.selected_scene_data?.video)
                video_ref.current.play()
            if(context.selected_scene_data?.audio)
                audio_ref.current.play()
            //fullscreen()
        }
    }, [context.require_user_click])

    return (
        <div id="cont" onDoubleClick={()=>fullscreen()}>
            {/* <input id="dev_checkbox" type="checkbox" defaultChecked={context.dev_mode} onChange={() => context.toogle_dev_mode()} /> */}
            
            { loading_overlay() }
            <div id="main">
                <div id="stage-parent">
                    <div className={ context.scene_visible ? 'fadeIn' : 'fadeOut' } onClick={()=>context.change_display_map(false)}>
                        { context.selected_scene_data?.video? '' : <img src={"images/" + context.selected_scene_data?.fondo || ''} className="scene-background" />}
                        <Video src={ context.selected_scene_data?.video || ''}></Video>
                        <Audio src={ context.selected_scene_data?.audio || ''}></Audio>
                        { generateAudioBoxes() }
                        { generateNavButtons() }
                    </div>
                    { (!context.require_user_click)? <img id="etqq_logo" onClick={()=>{context.change_display_map(false); history.push('IntroETQQ')}} className={"main-logo"} src={'images/ETQQ_ME01-Logo_White.png'}></img> : '' }
                    <Moveable ref={mov_ref} target={context.moveable_element} draggable={true} scalable={true} keepRatio={true} onDrag={on_drag} onScale={on_scale} onDragEnd={on_drag_end} onScaleEnd={on_scale_end} />
                    <Map scale={state.scale} />
                    { (!context.selected_scene_data?.video_controls && context.selected_scene !== 'IntroETQQ') ? <Menu fullscreen={fullscreen} is_fs={state.fs} /> : '' }
                    { renderVolver() }
                    { renderSaltarIntro() }
                </div>
            </div>
            <DevMenu />
            <SceneMenu  />
        </div>
    )
}

/* ------ AUX FUNCTIONS ------ */

function fullscreen() {
    try {
        if(!document.fullscreenElement) {
            document.body.requestFullscreen()
            setState(s=>({...s, fs: true}))
        } else {
            document.exitFullscreen()
            setState(s=>({...s, fs: false}))
        }
    } catch(e) {
        //setState(s=>({...s, fs: !s.fs}))
    }
    
}

function renderVolver() {
    if(context.selected_scene_data?.on_back || context.selected_scene_data?.on_end_go_to && context.selected_scene !== 'IntroETQQ')
        if(!context.require_user_click)
            if(!context.display_map)
                return <div className="volver-bot" onClick={()=>history.push(context.selected_scene_data?.on_back || context.selected_scene_data?.on_end_go_to)}>Volver &raquo;</div>
}

function renderSaltarIntro() {
    if(context.selected_scene === 'IntroETQQ')
        if(!context.require_user_click)
            return <div className="skip-bot" onClick={()=>history.push('ME01')}>Saltar intro &raquo;</div>        
}

function loading_overlay() {
    if(context.selected_scene_data?.video && context.video_loaded == false)
        return (
            <div className={'user_click_overlay'}>
                <Loader
                    type="Oval"
                    color="#FFFFFF"
                    height={80}
                    width={80}
                    className={'loading_spinner'}
                />
            </div>
        )
    else if(context.require_user_click == true)
        return (
            <div className={'user_click_overlay'} >
                <img src="images/bigplay.png" onClick={() => context.disable_require_user_click()}></img>
            </div>
        )
}

function Video(props) {
    return <video ref={video_ref} src={'videos/' + props.src} disablePictureInPicture controls={context.selected_scene_data?.video_controls} controlsList="nodownload nofullscreen"></video>
}

function Audio(props) {
    return <audio ref={audio_ref} loop src={'audios/' + props.src} style={{ display: 'none' }}></audio>
}

async function startup() {
    await context.fecthScenesList()
    context.startScene(location.pathname.substring(1))

    resize()
    window.addEventListener('resize', () => resize())
    keyboard_events()

    video_ref.current.addEventListener('canplay', () => {
        context.set_video_loaded(true)
        if(context.require_user_click == false) {
            if(context.selected_scene_data?.video)
                video_ref.current.play()
        }
    })

    video_ref.current.addEventListener('ended', () => {
        console.log("video ended")
        if(context.selected_scene_data?.on_end_go_to)
            history.push(context.selected_scene_data?.on_end_go_to)
        else            
            video_ref.current.play()
    })

    audio_ref.current.addEventListener('canplay', () => {
        if(context.require_user_click == false) {
            if(context.selected_scene_data?.audio)
                audio_ref.current.play()
        }
    })
}

function resize() {
    let p = document.querySelector('#main')
    let k = document.querySelector('#stage-parent')
    let scale = Math.min(p.offsetWidth/state.stageWidth, p.offsetHeight/state.stageHeight)
    k.style.transform = "translate(-50%, -50%) scale(" + scale + ")"
    setState(s=>({...s, scale}))
}

function generateAudioBoxes() {
    return context.selected_scene_data?.AudioBoxes?.map((d, box_index) => {
        return <AudioBox key={ 'ab-' + box_index + '-' + d.idd } index={ box_index } data={ d }></AudioBox>
    })
}

function generateNavButtons() {
    return context.selected_scene_data?.NavButtons?.map((d, index) => {
        return <NavButton key={ 'nb-' + index + '-' + d.idd } index={ index } data={ d }></NavButton>
    })
}

function on_drag({ target, left, top }) {
    last_top = top 
    last_left = left 
    target.style.top = last_top + 'px'
    target.style.left = last_left + 'px'
}

function on_drag_end({ target }) {
    context.editMoveableData(target.getAttribute("index"), last_left, last_top)
}

function on_scale({ target, transform }) {
    last_transform = transform
    target.style.transform = last_transform
}

function on_scale_end({ target }) {
    context.editMoveableData(target.getAttribute("index"), null, null, last_transform)
}

function keyboard_events() {
    const keycon = new KeyController()
    let d = 10

    keycon
        .keydown("1", e => {
            if(d==10)
                d = 2
            else if(d==2)
                d = 0.1
            else if(d==0.1)
                d = 10
        })
        .keydown("up", e => {
            //document.activeElement.blur()
            if(e.shiftKey)
                mov_ref.current.request("scalable", { deltaWidth: -d }, true)
            else
                mov_ref.current.request("draggable", { deltaY: -d }, true)
        })
        .keydown("down", e => {
            //document.activeElement.blur()
            if(e.shiftKey)
                mov_ref.current.request("scalable", { deltaWidth: d }, true)
            else
                mov_ref.current.request("draggable", { deltaY: d }, true)
        })
        .keydown("right", e => {
            //document.activeElement.blur()
            if(!e.shiftKey) 
                mov_ref.current.request("draggable", { deltaX: d }, true)
        })
        .keydown("left",  e => {
            //document.activeElement.blur()
            if(!e.shiftKey) 
                mov_ref.current.request("draggable", { deltaX:-d }, true)
        })
        .keydown("esc",  () => {
            //document.activeElement.blur()
            context.setMoveableElement(null)
        })
}